import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-dynamic-table-v2-column-option-dialog',
	templateUrl: './dynamic-table-v2-column-option-dialog.component.html',
	styleUrls: ['./dynamic-table-v2-column-option-dialog.component.scss'],
})
export class DynamicTableV2ColumnOptionDialogComponent {
	@Input() settings;
	@Input() module;
	@Input() columns;
	@Output() columnChanged = new EventEmitter();

	constructor(
		public dialogRef: MatDialogRef<DynamicTableV2ColumnOptionDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
	) {}

	protected showHideRow(itemCol, colSize): void {
		if (!this.data.settings.hiddenColumns.includes(itemCol)) {
			this.data.settings.hiddenColumns.push(itemCol);
			if (this.data.settings.size) this.data.settings.size = this.data.settings.size - +colSize;
		} else {
			this.data.settings.hiddenColumns.splice(this.data.settings.hiddenColumns.indexOf(itemCol), 1);
			if (this.data.settings.size) this.data.settings.size = this.data.settings.size + +colSize;
		}
		this.columnChanged.emit(this.data.settings);
		this.settingsSave();
	}

	private settingsSave(): void {
		localStorage.setItem('pageSettings-' + this.data.module, JSON.stringify(this.data.settings));
	}
}
